'use strict';
require('../../../modules/es.array.fill');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');

module.exports = getBuiltInPrototypeMethod('Array', 'fill');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/fill.js
// module id = 557
// module chunks = 13